import { actionType } from "../actions/fargerActions";
import * as reducerUtils from "../utils/reducerUtils";

const INITIAL_STATE = [];
const fargerReducer = (state = INITIAL_STATE, action) =>
  reducerUtils.CreateNewReducer(state, action, actionType);

export default fargerReducer;
